module.exports = __webpack_public_path__ + "fonts/constellaDrps.a7e3be0.ttf";